// client/src/locales/en

const en = {
  translation: {
    publication: {
      subjects: "Tout sujets", 
      sort: "Trier", 
      date_newest: "Sort par date (Nouveau)", 
      date_oldest: "Sort par date (Aîné)", 
      title_a_z: "Sort par titré (A-Z)", 
      title_z_a: "Sort par titré (Z-A)" ,
      nadaa: "Venez nous rencontrer sur notre stand : Aucun événement prévu pour l’instant.",
      search_placeholder: "Recherche par titre et auteur",
      date_from: "A partir de",
      date_to: "Jusqu'à",
      search_button: "Recherche",
      no_results: "No publication found."
    },
    shop: {
      order: "Votre ordre", 
      place_order: "Demander du matériel", 
      filter: "Tout les sujets", 
      download: "Download", 
      prev: "Étape précédente",
      form: "Données d'adresse",
      max: "Vous avez atteint le maximum autorisé pour ordre",
      aside_title: "Votre commande" , 
      selected_items: "éléments sélectionnés", 
      thanks: "Merci",
      form_submit: 'Commandez maintenant',
    },
    form: {
      form_submit: 'Soumettre',
      make_a_choice: 'Sélectionnez une option',
    },
    general: {
      readMore: 'Read more',
      loading: 'Loading',
      close: 'Close',
      disclaimer: 'Réservé aux professionnels de la nutrition et de la santé', 
    },
    blocks: {
      imageContainer: {
        error: 'Error loading image'
      },
      mapBlock: {
        visitWebsite: 'Visit website',
        map: 'Map',
        list: 'List',
      },
    },
    searchbar: {
      label: 'Que vous cherche?',
      placeholder: 'Exemple: nutrients du lait',
    },
    header: {
      language: 'local institutes: ',
    },
    regionSwitch: {
      title: "FrieslandCampina, your global dairy partner",
      description: "We are a worldwide dairy cooperation, operating in more than 50 countries",
      language: "Global"
    },
    footer: {
      links: {
        privacy: 'Privacy',
        terms_conditions: 'Terms & Conditions',
      },
      follow_us: 'Follow us',
    },
    404: {
      title: "Sorry, we can't find the page you're looking for",
      description:
        "It seems like the page doesn't exist (anymore) or perhaps is moved. Ofcourse you can always go back to our homepage.",
      link: '/',
      homepage: 'To homepage',
    },
    cookiebar: {
      title: 'Welcome!',
      description:
        "Probably you're already familiair with companies who are settings cookies on your desktop, tablet or phone. Friesland Campina is also using cookies and you can choose which ones.",
      accept: 'Accept',
      complete: {
        title: 'Complete cookies',
        description:
          "Met behulp van deze cookies verbeteren we de website, maken we een koppeling met social media, kunt u video's bekijken en een adviseur zoeken.",
      },
      limited: {
        title: 'Beperkte cookies',
        description:
          "Met deze cookies kunt u een adviseur zoeken, video's bekijken en kunnen wij de website verbeteren.",
      },
      functional: {
        title: 'Functionele cookies',
        description:
          "Deze cookies zijn noodzakelijk voor het functioneren van de website. U kunt geen video's bekijken en geen adviseur zoeken.",
      },
      decline: 'No, decline',
      statement: 'Cookie statement',
      missing: 'You need to enable our cookies to view this video.',
      settings: "Paramètres de cookies"
    },
    searchResults: {
      title: 'Vous as cherché',
      noSearchTerm: "tu n'as rien cherché",
      types: {
        article: "Article",
        page: 'Page',
        news: 'News',
        story: 'Story',
        webinar: "Webinar",
        conference: "Conference",
        events: "Event", 
      },
      noResults: 'Aucun résultat trouvé, essayez à nouveau avec les conseils suivants :',
      noResultsTips: {
        spelling: "Vérifier l'orthographe",
        describe: 'Décrivez votre recherche autrement',
        shorter: 'Raccourcissez votre recherche',
      },
    },
    filter: {
      noResults: 'There are no results found when filtering on this category. Please select a different category or click <a href="/frieslandcampina-news/">here</a> to go to the news overview.'
    },
    pagination: {
      previous: 'Previous',
      next: 'Next',
    },
    show_button: {
      more: 'Show more',
      less: 'Show less'
    },
    share_link: {
      title: 'Share on'
    },
    news: {
      categories: 'Categories:',
    },
    story: {
      categories: 'Categories:',
    },
    filters: {
      filter_on: 'Filter on:',
      category: 'Category',
      all_categories: 'All categories',
      year: 'Year',
      all_years: 'All years',
    },
    formMessage: 'Checking...',
    highlights: {
      title: 'Today at FrieslandCampina',
      footer_copy: 'Find out what else is going on at FrieslandCampina:',
      link_copy: 'Visit our newsroom',
      link_url: "/frieslandcampina-news/"
    },
    certificate:{
      download: "Cliquez ici pour télécharger votre certificat",
      find_download: "Vous trouverez ensuite le certificat dans le dossier de téléchargement"
    }
  },
}

export default en;
